import { BrowserRouter } from 'react-router-dom';
import '@fontsource/open-sans';
import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from 'assets/theme';
import SnackbarAlert from 'component/snackbar-alert/snackbar-alert';
import RouterView from 'routes';

const App: React.FC = () => {
    return (
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <SnackbarAlert />
                <RouterView />
            </ThemeProvider>
        </BrowserRouter>
    );
};

export default App;
